import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  tabs: {
    width: "645px",
    height: "42px",
    flexShrink: 0,
    background: theme.palette.background.paper,
    borderBottom: `1px solid ${theme.palette.divider}`,
    "& .MuiTab-root": {
      minHeight: "42px",
      fontSize: "14px",
      fontWeight: 400,
      fontStyle: "normal",
      lineHeight: "21px",
      letterSpacing: "0.04em",
      textTransform: "uppercase",
      color: theme.palette.text.primary,
      padding: 0,
      minWidth: "auto",
      flex: 1,
      fontFamily: "Noto Sans Hebrew",
    },
    "& .Mui-selected": {
      color: `${theme.palette.primary.main} !important`,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  tabsScrollable: {
    height: "44px",
    minHeight: "44px",
    "& .MuiTabs-scroller": {
      overflowX: "scroll !important",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },
    "& .MuiTabs-flexContainer": {
      flexWrap: "nowrap",
    },
    "& .MuiTab-root": {
      flex: "unset",
      flexShrink: 0,
      whiteSpace: "nowrap",
      padding: "0 12px",
    },
    "& .MuiTabs-scrollButtons": {
      display: "none",
    },
  },
}));
